import { useIntl } from 'react-intl';
import defaultLanguageCodeNames from '~/languageCodeNames.json';
import { usePostHog } from '@posthog/react';
import { useEffect } from 'react';

type LanguageNameProps = {
  languageCode: string;
  languageCodeNames?: Record<string, Record<string, string>>;
};

export const LanguageName = ({
  languageCode,
  languageCodeNames = defaultLanguageCodeNames,
}: LanguageNameProps) => {
  const posthog = usePostHog();
  const intl = useIntl();
  const languageWithTranslations = languageCodeNames[languageCode];
  useEffect(() => {
    if (!languageWithTranslations) {
      posthog?.capture('Language not found', { languageCode });
    }
  }, [languageCode, posthog, languageWithTranslations]);
  if (!languageWithTranslations) {
    return <>{languageCode}</>;
  }

  return <>{languageWithTranslations[intl.locale]}</>;
};

export default LanguageName;
